import { render, staticRenderFns } from "./StudentsProfie.vue?vue&type=template&id=c8f017c8&scoped=true&"
import script from "./StudentsProfie.vue?vue&type=script&lang=js&"
export * from "./StudentsProfie.vue?vue&type=script&lang=js&"
import style0 from "./StudentsProfie.vue?vue&type=style&index=0&id=c8f017c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f017c8",
  null
  
)

export default component.exports